import { t } from 'i18next';

function foldPolicy(record, policy) {
  Object.keys(record).forEach(attribute => {
    if (policy.attributes[attribute]) {
      record[`__${attribute}_policy`] = policy.attributes[attribute];
    }
  });
  record['__folded_policy'] = true;
  return record;
}

function validatePolicy(record, policy) {
  if (record['__folded_policy'] !== true && policy == null) {
    throw 'expected a policy object or for the record to have the policy folded in via Policy.fold()';
  }
  return Object.keys(record)
    .filter(
      attribute =>
        attribute.length > 2 && attribute[0] != '_' && attribute[1] != '_'
    )
    .reduce(
      (errors, attribute) =>
        errors.concat(validateAttributePolicy(record, attribute, policy)),
      []
    );
}

function validateAttributePolicy(record, attribute, policy) {
  let attributePolicy = record[`__${attribute}_policy`];
  let foldedPolicy = record['__folded_policy'] === true;
  if (!foldedPolicy) {
    if (policy == null) {
      throw 'expected a policy object or for the record to have the policy folded in via Policy.fold()';
    }
    attributePolicy = policy.attributes[attribute];
  }
  let attributeErrors = [];
  if (attributePolicy) {
    let attributePolicyCustomValidators = attributePolicy.validators || [];
    attributeErrors = attributeErrors
      .concat(
        validateAttributePolicyRequired(record, attribute, attributePolicy)
      )
      .concat(validateAttributePolicyFormat(record, attribute, attributePolicy))
      .concat(
        validateAttributePolicyLength(record, attribute, attributePolicy)
      );
    attributePolicyCustomValidators.forEach(
      validator =>
        (attributeErrors = attributeErrors.concat(
          validator(record, attribute, attributePolicy) || []
        ))
    );
    if (foldedPolicy) {
      record[`__${attribute}_policy_error`] =
        attributeErrors.length > 0 ? attributeErrors.join(',') : null;
    }
  }
  return attributeErrors;
}

function validateAttributePolicyRequired(record, attribute, attributePolicy) {
  if (attributePolicy.required === true) {
    let attributeValue = record[attribute] || '';
    if (attributeValue.length == 0) {
      return [
        t('{{attribute}} is a required field', { attribute: '{attribute}' }),
      ];
    }
  }
  return [];
}

function validateAttributePolicyFormat(record, attribute, attributePolicy) {
  if (attributePolicy.format != null && attributePolicy.format.with != null) {
    let attributeValue = record[attribute] || '';
    if (attributeValue.length > 0) {
      let regexParts = attributePolicy.format.with.split(':', 2);
      let regexPattern = '(?:' + regexParts[1];
      regexPattern = regexPattern.replace('\\A', '^');
      regexPattern = regexPattern.replace('\\z', '$');
      let regexOptions = regexParts[0].split('-')[0].split('?')[1];
      let regex = new RegExp(regexPattern, regexOptions);
      if (regex.test(record[attribute]) !== true) {
        return [
          attributePolicy.format.message ||
            t('{{attribute}} not valid', { attribute: '{attribute}' }),
        ];
      }
    }
  }
  return [];
}

function validateAttributePolicyLength(record, attribute, attributePolicy) {
  if (attributePolicy.length != null) {
    let attributeValue = record[attribute] || '';
    if (
      attributePolicy.length.minimum &&
      attributeValue.length < attributePolicy.length.minimum
    ) {
      return [t('{{attribute}} is too short', { attribute: '{attribute}' })];
    }
    if (
      attributePolicy.length.maximum &&
      attributeValue.length > attributePolicy.length.maximum
    ) {
      return [t('{{attribute}} is too long', { attribute: '{attribute}' })];
    }
  }
  return [];
}

function unfoldPolicy(record) {
  let result = {};
  Object.keys(record)
    .filter(
      attribute =>
        attribute.length > 2 && attribute[0] != '_' && attribute[1] != '_'
    )
    .forEach(attribute => (result[attribute] = record[attribute]));
  return result;
}

export default class Policy {
  static fold(record, policy) {
    return foldPolicy(record, policy);
  }
  static validate(record, policy) {
    return validatePolicy(record, policy);
  }
  static isValid(record, policy) {
    return validatePolicy(record, policy).length == 0;
  }
  static validateAttribute(record, attribute, policy) {
    return validateAttributePolicy(record, attribute, policy);
  }
  static isAttributeValid(record, attribute, policy) {
    return validateAttributePolicy(record, attribute, policy).length == 0;
  }
  static unfold(record) {
    return unfoldPolicy(record);
  }
  static registerAttributeValidator(policy, attribute, validator) {
    let attributePolicy = policy.attributes[attribute];
    attributePolicy.validators = attributePolicy.validators || [];
    attributePolicy.validators.push(validator);
  }
  static setting(policy, setting) {
    if (policy && policy.settings) {
      return policy.settings[setting] === true;
    }
    return false;
  }
}
